import * as React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

const LandingImages = ({ blok }) => {
  const imgLen = blok.images.length
  // console.log(blok)
  return (
    <div id={blok?.id} {...storyblokEditable(blok)} style={{
      paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px`, 
      paddingLeft: `${blok.paddingLeft}px`, paddingRight: `${blok.paddingRight}px`,
      marginTop: `${blok.marginTop}px`, marginBottom: `${blok.marginBottom}px`, 
      backgroundColor: `${blok.bgColor?.color}` }}>
      <div className="container max-w-screen-xl mx-auto py-5">
        <div className={`grid grid-cols-1 gap-y-10 gap-x-10
          ${imgLen % 2 === 0 ? 'md:grid-cols-2' : ''}
          ${imgLen % 3 === 0 ? 'md:grid-cols-3' : ''}`}>
          {
            blok.images.map((img, i) => {return (
              <div className="" key={i}>
                <img className={`w-full rounded-md ${blok.ratio === 'square' ? 'aspect-square object-cover' : 'object-contain' }`} 
                  loading="lazy" src={`${img.filename}/m/`} alt={img.alt} />
                {img.name && <p className="text-center p-5 font-serif">{img.name}</p> }
              </div>)}
          )}
        </div>
      </div>
    </div>)
}

export default LandingImages
